import Render from 'common/Render';
import makeRoutes from './routes';
import _debug from 'debug';
import $ from 'jquery';
import fetch from 'utils/fetch';
import { error } from 'plugins/toastr';
import { hideLoader } from 'plugins/loader';
import { Maybe } from 'monet';
import { displayConfirmModalIfRequired } from 'plugins/confirm-action';
import { serializeErrors } from './actions/diagnostic';
import {
  getCreatedCaseSites,
  getUpdatedCaseSites,
  getDeletedCaseSites,
} from './reducers/sites';
import { getSerializedDiagnostics } from './reducers/diagnostic';
import { getIsDirty } from './reducers/dirty';
import { tryParseTaskType } from 'saas/constants';
import { tryParseNumber } from 'utils/parse';
import { withReferer } from 'plugins/contextual-back';

require('plugins/are-you-sure');

const debug = _debug('app::case');

export default function form(siteCase, isNew = false) {
  debug('Rendering case form', siteCase);

  const store = Render.render(store => makeRoutes(store, siteCase, isNew));
  bind(store, siteCase);

  const dirtyHandler = () => {
    if (getIsDirty(store.getState())) {
      $('#case-form').addClass('dirty');
    }
  };

  store.subscribe(dirtyHandler);

  return store;
}

function bind(store, siteCase) {
  // Trigger submit
  const $form = $('#case-form');
  const $button = $('#bt-save');
  const $buttonEstimate = $('#bt-establish-estimate');

  // Enable dirty form
  $form.areYouSure();

  $button.off('click').on('click', evt => {
    evt.preventDefault();

    // Handling confirm action modal
    displayConfirmModalIfRequired($button, () => $form.submit());
  });

  $buttonEstimate.off('click').on('click', evt => {
    evt.preventDefault();

    // Handling confirm action modal
    displayConfirmModalIfRequired($button, () => {
      $('#bt-establish-estimate').data('activated', true);
      $form.submit();
    });
  });

  // Handling submit and serialization
  $form.off('submit').on('submit', evt => {
    evt.preventDefault();

    const $form = $(evt.currentTarget);
    $form.removeClass('dirty');
    const data = new FormData($form[0]);

    // Adding site cases to form data
    const siteCases = serializeStore(store);
    data.append('siteCases', JSON.stringify(siteCases));

    // Submitting
    const url = $form.attr('action');
    fetch(url, {
      method: 'POST',
      body: data,
    }).then(
      res => {
        if ($('#bt-establish-estimate').data('activated')) {
          const action = $('#bt-establish-estimate').attr('data-action');
          fetch(action, {
            method: 'POST',
          }).then(
            res => {
              window.location.assign(
                withReferer(res.url, `/pco-manager/cases/${siteCase}`)
              );
            },
            err => {
              console.log('Error attempting to establish estimate', err);

              error('Une erreur est survenue pendant la génération du devis');
            }
          );
        } else {
          if (res.url) {
            window.location.replace(res.url);
          } else {
            window.location.reload(true);
          }
        }
      },
      err => {
        console.log('Error attempting to save case', err);

        $('#bt-establish-estimate').data('activated', false);
        hideLoader();

        if (err.res.status === 400) {
          // Handling errors properly
          err.res.json().then(json => handleFormErrors(store, $form, json));
        } else {
          error('Une erreur est survenue pendant la sauvegarde du dossier');
        }
      }
    );

    return false;
  });
}

function handleFormErrors(store, $form, errors) {
  // Clearing existing errors
  $form.find('.field').removeClass('error');

  const formError = errors[0];
  if (formError && formError.key) {
    $form
      .find(`input[name="${formError.key}"]`)
      .closest('.field')
      .addClass('error');
  }

  // Dispatching to redux (for UI bindings purpose)
  dispatchErrors(store, errors);
}

function serializeStore(store) {
  if (store) {
    const state = store.getState();

    const serialized = {};

    serialized['new_case_sites'] = getCreatedCaseSites(state);
    serialized['updated_case_sites'] = getUpdatedCaseSites(state);
    serialized['deleted_case_sites'] = getDeletedCaseSites(state);
    serialized['diagnostics'] = getSerializedDiagnostics(state);

    return serialized;
  }

  console.log('Trying to serialize an empty store');
  return null;
}

function dispatchErrors(store, error) {
  const errors = Object.keys(error)
    .map(key => {
      const values = key.split(/[..]/);

      const tryExtractValue = func =>
        values
          .map(v => Maybe.fromNull(func(v)))
          .filter(v => v.isSome())
          .map(v => v.some())[0];

      const site = tryExtractValue(tryParseNumber);
      const type = tryExtractValue(tryParseTaskType);

      if (site) {
        if (type) {
          // Diagnostic fields errors
          const field = key.substring(
            key.indexOf(type.toLowerCase()) + type.length + 1
          );

          return {
            site,
            type,
            field,
          };
        } else {
          // Site fields errors
          const field = key.substring(
            key.indexOf(site.toString()) + site.toString().length + 1
          );

          return {
            site,
            field,
          };
        }
      }

      if (!site && !type) {
        return {
          site: 0,
          field: key.substring(4),
        };
      }

      return null;
    })
    .filter(e => e !== null);

  store.dispatch(serializeErrors(errors));
}



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/form/index.js